import React from "react";
import {
  AppBar,
  Toolbar,
  Container,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Hidden
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import { makeStyles } from "@material-ui/core";
import CellarTech from "../images/cellarTech.png";
// import { Link, animateScroll as scroll } from "react-scroll";
import { NavHashLink } from "react-router-hash-link";
import "./navbar.css";
import SideDrawer from "./sideDrawer";
import { StyledButton } from "../helpers/button";

const useStyles = makeStyles({
  navDisplayFlex: {
    display: `flex`,
    justifyContent: `space-between`,
    alignItems: "center",
    height: 70
  },
  rightMenu: {
    display: `flex`,
    alignItems: "center",
    justifyContent: `space-between`,
    flex: ".6"
  },
  linkText: {
    textDecoration: `none`,
    textTransform: `uppercase`,
    color: `white`
  },
  button: {
    boxShadow: "0px 14px 30px #00000029",
    borderRadius: 15,
    opacity: 1,
    height: 40,
    width: 60,
    backgroundColor: "#fff",
    color: "#2498FB",
    "&:hover": {
      backgroundColor: "#fff"
    },
    "&:focus": {
      backgroundColor: "#fff"
    }
  }
});

const navLinks = [
  { title: `Home`, path: `#home` },
  { title: `About`, path: `#about` },
  { title: `Services`, path: `#services` },
  { title: `Portolio`, path: `#portfolio` },
  { title: `Testimonial`, path: `#testimonial` }
];

const Header = () => {
  const classes = useStyles();
  return (
    <AppBar position="sticky" style={{ background: "#2A2A2A", height: 70 }}>
      <Toolbar
        className={classes.navbarDisplayFlex}
        style={{ justifyContent: "space-between" }}
      >
        <img src={CellarTech} style={{ height: 56 }} alt={"cellarTech Logo"} />
        <Hidden smDown>
          <div className={classes.rightMenu}>
            <List
              component="nav"
              aria-labelledby="main navigation"
              className={classes.navDisplayFlex}
            >
              {navLinks.map(({ title, path }) => (
                <ListItem
                  button
                  activeClassName="active"
                  to={path}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  component={NavHashLink}
                >
                  <ListItemText primary={title} />
                </ListItem>
              ))}
            </List>
            <div style={{ minWidth: 280 }}>
              <StyledButton
                maxWidth={"130px"}
                component={"a"}
                href="tel:+919669555126"
                height={"40px"}
                style={{ fontSize: ".8em" }}
              >
                Get A Quote
              </StyledButton>
              <ButtonGroup
                variant="contained"
                color="primary"
                aria-label="call or Email Us"
              >
                <Button
                  component={"a"}
                  href="tel:+919669555126"
                  className={classes.button}
                >
                  <i class="fa fa-phone" aria-hidden="true"></i>
                </Button>
                <Button
                  component={"a"}
                  href="mailto:gurjarnikhil2022@gmail.com"
                  className={classes.button}
                >
                  <i class="fa fa-envelope" aria-hidden="true"></i>
                </Button>
              </ButtonGroup>
            </div>
          </div>
        </Hidden>
        <Hidden mdUp>
          <SideDrawer navLinks={navLinks} />
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};
export default Header;
